module.exports = __webpack_public_path__ + "Didot.woff?2c3c92fd54e35dc99bdb7a98e1cb0f3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/didot/Didot.woff
// module id = 312
// module chunks = 0